import React from 'react';
import cx from 'classnames';

import type {
  WThemeView,
  WThemeGroupView,
  WThemeGroupDetailView,
  WThemeDetailView,
} from '@zola/svc-web-api-ts-client';

import {
  getThemeUniqueIdentifier,
  getThemePdpSwatchColors,
} from 'pages/WebsiteDesignsPLPSSR/helpers';

// styles
import {
  SwatchContainer,
  SwatchHalf,
  SwatchInnerContainer,
  SwatchRow,
} from './PdpThemeSwatches.styles';

type PdpThemeSwatchesProps = {
  themeOptions: WThemeGroupView | WThemeGroupDetailView | undefined;
  currentTheme: WThemeView | WThemeDetailView | undefined;
  onSwatchClick: (theme: WThemeView, localThemeGroupKey?: string) => void;
};

const PdpThemeSwatches: React.FC<PdpThemeSwatchesProps> = ({
  themeOptions,
  currentTheme,
  onSwatchClick,
}) => {
  const onSwatchClickHandler = (theme: WThemeView, localThemeGroupKey: string) => {
    onSwatchClick(theme, localThemeGroupKey);
  };

  const isSelected = (theme: WThemeView) => {
    return getThemeUniqueIdentifier(theme) === getThemeUniqueIdentifier(currentTheme);
  };

  const swatches: Array<JSX.Element> = [];
  const swatchOptions = themeOptions?.themes;
  if (swatchOptions) {
    swatchOptions.map((themes: WThemeView, i: number) => {
      const swatchColors = getThemePdpSwatchColors(themes);
      return swatches.push(
        <SwatchContainer
          active={isSelected(themes)}
          className={cx('swatch-container', { active: isSelected(themes) })}
          onClick={() => {
            if (themeOptions?.themes?.[0].key) {
              onSwatchClickHandler(themes, themeOptions?.themes[0]?.key);
            }
          }}
          key={`SwatchContainer--${i}`}
        >
          <SwatchInnerContainer
            key={`SwatchInnerContainer--${i}`}
            color={`#${swatchColors.primary}`}
          >
            <div>
              <SwatchHalf color={`#${swatchColors.primary}`} />
              <SwatchHalf color={`#${swatchColors.secondary}`} />
            </div>
          </SwatchInnerContainer>
        </SwatchContainer>
      );
    });
  }

  return <SwatchRow mobileVisibility>{swatches}</SwatchRow>;
};

export default PdpThemeSwatches;
